import { render, staticRenderFns } from "./DocumentInput.vue?vue&type=template&id=d4b801ba&scoped=true"
import script from "./DocumentInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DocumentInput.vue?vue&type=style&index=0&id=d4b801ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b801ba",
  null
  
)

export default component.exports